import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import * as SharedActions from '@states/shared/shared.actions';
import { catchError, map, mergeMap, share, switchMap } from 'rxjs';
import { UniformsActions } from '@states/uniforms/uniforms.action-types';
import { UniformsService } from 'src/app/development/uniforms.service';

@Injectable()
export class UniformsEffect {

  public getSavedUniforms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UniformsActions.getSavedUniforms),
      mergeMap(() => {
        return this.uniformsService.getSavedUniforms()
          .pipe(
            switchMap(res => {
              return [UniformsActions.getSavedUniformsSuccess({ uniforms: res }), SharedActions.setIsLoading({ isLoading: false })];
            }),
            catchError(error => {
              return [SharedActions.setIsLoading({ isLoading: false }), UniformsActions.getSavedUniformsError({ error })];
            }),
          );
      }),
      share(),
    ),
  );

  public getSuggestedUniforms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UniformsActions.getSuggestedUniforms),
      mergeMap(() => {
        return this.uniformsService.getSuggestedUniforms()
          .pipe(
            switchMap(res => {
              return [
                UniformsActions.getSuggestedUniformsSuccess({ suggestedUniforms: res }), SharedActions.setIsLoading({ isLoading: false })];
            }),
            catchError(error => {
              return [SharedActions.setIsLoading({ isLoading: false }), UniformsActions.getSuggestedUniformsError({ error })];
            }),
          );
      }),
      share(),
    ),
  );

  public startTraining$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UniformsActions.startTraining),
      mergeMap(({ request }) => {
        return this.uniformsService.training(request)
          .pipe(
            switchMap(res => {
              return [UniformsActions.startTrainingSuccess({ response: res })];
            }),
            catchError(error => {
              return [UniformsActions.startTrainingError({ error })];
            }),
          );
      }),
      share(),
    ),
  );

  public closeTraining$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UniformsActions.closeTraining),
      mergeMap(({ request }) => {
        return this.uniformsService.closeTraining(request)
          .pipe(
            switchMap(res => {
              return [UniformsActions.closeTrainingSuccess({ uniform: res })];
            }),
            catchError(error => {
              return [UniformsActions.closeTrainingError({ error })];
            }),
          );
      }),
      share(),
    ),
  );

  public deleteUniform$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UniformsActions.deleteUniform),
      mergeMap(({ uniformId }) => {
        return this.uniformsService.deleteUniform(uniformId)
          .pipe(
            switchMap(() => {
              return [UniformsActions.deleteUniformSuccess({ uniformId })];
            }),
            catchError(error => {
              return [UniformsActions.deleteUniformError({ error })];
            }),
          );
      }),
      share(),
    ),
  );

  public updateUniformName$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UniformsActions.updateUniformName),
      mergeMap(({ uniformId, name }) => {
        return this.uniformsService.updateUniformName(uniformId, name)
          .pipe(
            switchMap(res => {
              return [UniformsActions.updateUniformNameSuccess({ uniform: res })];
            }),
            catchError(error => {
              return [UniformsActions.updateUniformNameError({ error })];
            }),
          );
      }),
      share(),
    ),
  );

  private catchError(response: any) {
    console.error('Uniforms Effect Error:', response);
    return SharedActions.showMessage({ error: response?.error?.message || 'An error occurred with uniforms' });
  }

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    private uniformsService: UniformsService,
  ) {}
} 